import { Typography, Box, Button } from '@mui/material';

// Rendered by the top-level ErrorBoundary when a render error is caught. Self-contained
// (no ContainerMain / config dependency) so it still shows even if config or layout is
// what failed. Lives inside ThemeProvider, so MUI theming is safe to use here.
function ErrorBody() {
    return (
        <Box
            sx={{
                minHeight: '100dvh',
                maxWidth: 480,
                mx: 'auto',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                px: 2,
            }}>
            <Box sx={{ flex: 1 }} />
            <Typography align='center' variant='m_logo' color='primary.main'>
                {import.meta.env.VITE_SERVICE_TITLE}
            </Typography>
            <Typography align='center' variant='m_overline' color='primary.main' sx={{ mt: 1 }}>
                {import.meta.env.VITE_SERVICE_TAGLINE}
            </Typography>
            <Box sx={{ flex: 0.618 }} />
            <Typography align='center' color='text.primary' variant='m_titleM'>
                Something went wrong
            </Typography>
            <Typography align='center' variant='body2' color='text.secondary' sx={{ mt: 1 }}>
                An unexpected error occurred. Please reload and try again.
            </Typography>
            <Button variant='contained' onClick={() => window.location.reload()} sx={{ mt: 3 }}>
                Reload
            </Button>
            <Box sx={{ flex: 1.618 }} />
        </Box>
    );
}

export { ErrorBody };
